export const Badge = ({ text, color = "blue" }) => {
    const colors = {
        blue: "bg-blue-500 text-white",
        red: "bg-red-500 text-white",
        green: "bg-green-500 text-white",
        yellow: "bg-yellow-500 text-black",
        gray: "bg-gray-500 text-white",
        orange: "bg-orange-400 text-white"
    };

    return (
        <span
            className={`m-2 px-3 py-1 text-sm font-semibold rounded-lg text-nowrap ${colors[color]}`}
        >
            {text}
        </span>
    );
};
